import store from '@/store'
const commonView = () => import(/* webpackChunkName: "common" */ '@/components/common/commonView.vue')
const operatorGroupList = () => import(/* webpackChunkName: "operator-group" */ '@/views/operator-group/list.vue')
const operatorGroupAdd = () => import(/* webpackChunkName: "operator-group" */ '@/views/operator-group/add.vue')
const operatorGroupModify = () => import(/* webpackChunkName: "operator-group" */ '@/views/operator-group/modify.vue')
export default {
    path: 'operator-group',
    name: 'operator-group',
    meta: { title: '操作员组' },
    component: commonView,
    redirect: '/main/:GD/operator-group/list',
    beforeEnter: (to, from, next) => {
      if (store.getters.getpermission.opergroup[0] != '1') return next({ name: 'no-permission', params: to.params})
      next()
    },
    children: [
      {
        path: 'list',
        name: 'operator-group-list',
        meta: { title: '操作员组' },
        component: operatorGroupList,
      },
      {
        path: 'add',
        name: 'operator-group-add',
        meta: { title: '新增操作员组' },
        component: operatorGroupAdd,
      },
      {
        path: 'modify',
        name: 'operator-group-modify',
        meta: { title: '修改操作员组' },
        component: operatorGroupModify,
      },
    ]
}
